// Campus photo for /colleges/university-of-massachusetts-amherst: CC BY 4.0, by Quintin Soloviev, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUMass_Amherst_campus_aerial_view.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-massachusetts-amherst/; credited under the photo.
const photo = {
    "slug": "university-of-massachusetts-amherst",
    "alt": "Aerial view of the University of Massachusetts Amherst campus in autumn, with the Southwest Residential Area in front and the W. E. B. Du Bois Library at center",
    "src": "/colleges/university-of-massachusetts-amherst/campus-1600.webp",
    "srcSmall": "/colleges/university-of-massachusetts-amherst/campus-800.webp",
    "srcMid": "/colleges/university-of-massachusetts-amherst/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-massachusetts-amherst/og.jpg",
    "title": "UMass Amherst campus aerial view",
    "author": "Quintin Soloviev",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUMass_Amherst_campus_aerial_view.jpg",
    "read": "2026-10-01"
};

export default photo;
